import { render, staticRenderFns } from "./BusinessInfo.vue?vue&type=template&id=6a46bef4&scoped=true&"
import script from "./BusinessInfo.vue?vue&type=script&lang=js&"
export * from "./BusinessInfo.vue?vue&type=script&lang=js&"
import style0 from "./BusinessInfo.vue?vue&type=style&index=0&id=6a46bef4&lang=less&scoped=true&"
import style1 from "./BusinessInfo.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a46bef4",
  null
  
)

export default component.exports